<template>
    <OverlayDialog
        :id="modalId"
        :show-trigger="false"
        modal-button-label="Fermer"
    >
        <PriceDetailsContent
            :id="id"
            :offer-type="offerType"
            :offer-name="offerName"
            :offer-price="offerPrice"
            :price-details="priceDetails"
        />
    </OverlayDialog>
</template>

<script lang="ts">
import {
    PriceDetailsPopinDto
} from "../../../../common/components/custom/models/PriceDetailsPopinDto";
import {PropType} from "vue";
import {PrixDTO} from "../../../common/configurator/models/InsuranceCrossSellOptionWithUnknownDevice";
import PriceDetailsContent from "./PriceDetailsContent.vue";
import OverlayDialog from "../../../../common/components/ob1/OverlayDialog.vue";

export default {
    name: "PriceDetailsPopin",
    components: {
        PriceDetailsContent,
        OverlayDialog,
    },
    props: {
        id: {
            type: String,
            required: true,
        },
        offerType: {
            type: String,
            required: true,
        },
        offerName: {
            type: String,
            required: true,
        },
        offerPrice: {
            type: Object as PropType<PrixDTO>,
            required: true,
        },
        priceDetails: {
            type: Object as PropType<PriceDetailsPopinDto>,
            required: true,
        },
    },
    computed: {
        modalId() {
            return `price-details-popin-${this.id}`;
        },
    },
};
</script>
